/* eslint-disable */
import girl1 from '../assets/svg/testimonials/girl1.svg'
import girl2 from '../assets/svg/testimonials/girl2.svg'
import girl3 from '../assets/svg/testimonials/girl3.svg'
import boy1 from '../assets/svg/testimonials/boy1.svg'
import boy2 from '../assets/svg/testimonials/boy2.svg'
import boy3 from '../assets/svg/testimonials/boy3.svg'



export const testimonialsData = [
    {
        id: 1,
        name: 'Shivam Kapoor',
        title: 'Penetration Tester & Synack Red Team Member',
        text: "Ahad is incredibly talented, always willing to assist me, and a fantastic team player.",
        image: boy2
    },
    {
        id: 2,
        name: 'Hafiz M. Attaullah',
        title: 'CISO/CEO Nanotechx',
        text: "Ahad is one of the most dedicated professionals I’ve worked with and is willing to put that extra help whenever you need it. His expertise as a PenTester is considerable, and it helped our team come up with more efficient solutions at different stages. I highly recommend him and appreciate his services for our company NANOTECHX.",
        image: boy1
    },
    {
        id: 3,
        name: 'Innayatullah',
        title: 'Full Stack Developer',
        text: "Ahad is very dedicated to the Work he does. Experienced developer & Penetration Tester with knowledge of various latest technologies. :)",
        image: boy3
    },
    {
        id: 4,
        name: 'Joey Tribbiani',
        title: 'Actor',
        text: "Making my portfolio with this helped me get my role as 'Dr. Drake Ramoray' in 'Days Of Our Lives'. You guys are the best !",
        image: girl1
    },
    {
        id: 5,
        name: 'Rachel Green',
        title: 'Sales Executive',
        text: 'Ralph Lauren was one of the best things that ever happened to me. My portfolio made that dream happen. I owe you guys.',
        image: girl3
    },
    {
        id: 6,
        name: 'Ross Geller',
        title: 'Paleontologist',
        text: "Be it 'Rocks' or 'Bones', you need a website to display it. This is it. Great work guys !",
        image: girl2
    }
]

